module.exports = __webpack_public_path__ + "dd77cc9a389082233e62920ec8b28c40.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/patterns/4.png
// module id = 101
// module chunks = 1